<script setup lang="ts">
	import type { ClassNameValue } from 'tailwind-merge'
	import { cn } from '~/utils/functions'

	const selectedOptions = defineModel<string>()
	export type DisclaimerRadioOptionContext = {
		key: 'instant' | 'pending'
		title: {
			value: string
			className?: ClassNameValue
		}
		description: {
			value: string
			className?: ClassNameValue
		}
		readonly?: boolean
	}[]

	defineProps<{
		list?: DisclaimerRadioOptionContext | null
		labelCls?: ClassNameValue
	}>()
</script>

<template>
	<a-radio-group v-model:value="selectedOptions">
		<div class="item-center flex grid-cols-2 flex-wrap gap-3 sm:grid">
			<label
				v-for="(item, index) in list"
				:key="`option-${index}`"
				role="button"
				aria-label="option"
				:class="
					cn(
						'mx-auto inline-flex max-w-[274px] cursor-pointer items-center justify-center rounded border px-3 pb-[37px] pt-5',
						item.key != selectedOptions && 'border-[#eaecf0] bg-[#f8f9fb]',
						item.key === selectedOptions && 'border-2 border-primary-2 bg-success-25',
						labelCls
					)
				"
			>
				<div class="inline-flex flex-col items-start justify-start gap-4">
					<a-radio :disabled="item?.readonly ?? false" :value="item.key" class="custom-radio-class" />
					<div class="flex flex-col items-start justify-start gap-2 self-stretch">
						<h6 :class="cn('text-base font-semibold leading-tight', item.title?.className)">
							<slot name="title">
								{{ item.title.value }}
							</slot>
						</h6>
						<div class="text-sm font-medium leading-relaxed text-gray-500">
							<slot name="description">
								<span
									:class="
										cn(
											'text-sm font-medium leading-relaxed text-gray-500',
											item.description?.className
										)
									"
									v-html="item.description.value"
								/>
							</slot>
						</div>
					</div>
				</div>
			</label>
		</div>
	</a-radio-group>
</template>
